import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import BaseComponent from 'utils/BaseComponent'
import request from 'utils/request'

import Select from 'components/Select'
import Button from 'components/Button'

import AddWorkshop from './AddWorkshop'

import { WORKSHOPS_URL, CLAIM_UPDATE } from 'constants'

import { changeWorkshop, changeEditting, newWorkshop } from '../actions'
import { statusChanged } from 'components/RequestStatus/actions'

import './styles.scss'

export class SelectWorkshop extends BaseComponent {

  constructor() {
    super()

    this._bind('_showNewWorkshop', '_fetchWorkshops', '_onSelectChange', '_handleSubmit')
  }

  _fetchWorkshops(value) {
    return request(WORKSHOPS_URL)
      .then((response) => {
        const options = response.workshops.map((item) => ( { value: item.id, label: item.name } ))

        return { options }
      })
  }

  _showNewWorkshop() {
    this.context.toggleModal(true,
      <AddWorkshop />
    )
  }

  _onSelectChange(selectedOption) {
    this.props.changeWorkshop(selectedOption)
  }

  _handleSubmit(e) {
    e.preventDefault()
    const formData = new FormData()
    formData.append('workshop', this.props.workshop.value)
    this.props.updateRequestStatus('progress', 'Cambio de datos en progreso...')
    request(CLAIM_UPDATE(this.props.claimId), {
      method: 'PUT',
      isUpload: true,
      body: formData
    }).then((res) => {
      this.props.newWorkshop(true)
      this.props.updateRequestStatus('ok', 'Actualizado correctamente')
    })
      .catch((err) => {this.props.updateRequestStatus('error', 'No pudimos asignar el nuevo taller')})

    this.props.changeEditting(false)
  }

  render() {
    return (
      <form onSubmit={this._handleSubmit} className="d-flex flex-column SelectWorkshop">
        {/*
        <div className="d-flex align-items-center ">
          <Select
            cache={false}
            errors={[]}
            label="Seleccionar taller"
            loadingPlaceholder="Buscando..."
            loadOptions={this._fetchWorkshops}
            placeholder=""
            searchPromptText=""
            onChange={(selectedOption) => this._onSelectChange(selectedOption)}
            value={!!this.props.workshop.value  ? this.props.workshop : null} />

          <i onClick={this._showNewWorkshop} className="material-icons">add</i>
        </div>
        */}
        <div className="d-flex align-items-center form-select-field">
            <label>Seleccionar taller:</label>
            <Select
                    cache={false}
                    errors={[]}
                    loadingPlaceholder="Buscando..."
                    loadOptions={this._fetchWorkshops}
                    placeholder=""
                    searchPromptText=""
                    onChange={(selectedOption) => this._onSelectChange(selectedOption)}
                    value={!!this.props.workshop.value  ? this.props.workshop : null} />

            <i onClick={this._showNewWorkshop} className="material-icons">add</i>
          </div>
        <div className="controls">
          <Button buttonType="primary"
                  size="small">Cambiar Taller</Button>
        </div>
      </form>
    )
  }
}

SelectWorkshop.contextTypes = {
  toggleModal: PropTypes.func.isRequired
}


const mapStateToProps = (state) => {
  return {
    workshop: state.selectWorkshop.get('workshop')
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    changeWorkshop: (workshop) => dispatch(changeWorkshop(workshop)),
    changeEditting: (editting) => dispatch(changeEditting(editting)),
    newWorkshop: (state) => dispatch(newWorkshop(state)),
    updateRequestStatus: (status, message) => dispatch(statusChanged(status, message))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectWorkshop)



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/ClaimData/Workshop/SelectWorkshop/index.js